module.exports = __webpack_public_path__ + "static-portal/media/bjsp.02273f6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bjsp.mp4
// module id = 6DB6
// module chunks = 4